<template>
  <v-dialog fullscreen v-model="dialog">
    <v-sheet
      class="fill-height d-flex flex-column justify-start"
      color="black"
      style="opacity: .9"
      tile
    >
      <div style="position:absolute; top:10px; right:10px;">
        <v-btn
          @click="$emit('close')"
          color="grey darken-4"
          dark
          class="caption"
        >
          close
        </v-btn>
      </div>
      <div
        class="flex-fill flex-column d-flex justify-center align-center black white--text py-8 px-sm-0"
      >
        <div v-if="body" v-html="body"></div>
        <div v-else class="text-center">
          <img
            alt="metaPOLIS"
            src="../assets/metapolis-logox1-inverted.png"
            width="200"
          />
          <p class="font-weight-light px-11 mt-11 text-center">
            <span class="title">Staying at home</span><br />
            <span class="subtitle-1"
              >…Μείναμε σπίτι αλλά δεν μείναμε μόνοι μας</span
            >
          </p>
          <p
            class="font-weight-light px-11 mt-11 text-center"
            style="max-width: 800px"
          >
            Το METApolis είναι το μέρος όπου η σύγχρονη φωτογραφία συνέχισε και
            συνεχίζει στα χρόνια του Covid19 να συναντά την αισθητική και την
            τεχνική. Εκεί όπου οι ανήσυχοι και τολμηροί δημιουργοί βρίσκουν τα
            εκφραστικά μέσα να δημιουργήσουν, ένας τόπος όπου πυροδοτούνται
            συζητήσεις για την Τέχνη της Φωτογραφίας.
          </p>
          <p
            class="font-weight-light px-11 mb-11 text-center"
            style="max-width: 800px"
          >
            Έτσι εκείνο το βράδυ, Τρίτη 10 Μαρτίου 2020 που έπρεπε όλοι να
            “μείνουμε σπίτι” στην οικογένεια του μεταπολις καταφέραμε και
            βρήκαμε νέους τρόπους επικοινωνίας, γεμίσαμε με νέα App ( Zoom,
            Meet, Teams…). Έτσι μοιραστήκαμε πολλά βράδια την αγάπη μας για την
            φωτογραφία, με παρουσιάσεις των δασκάλων για τους μεγάλους
            φωτογράφους, με ανάπτυξη στις έννοιες του εγκλεισμού και πως η
            φωτογραφία καταγράφει τα τελευταία σχεδόν 200 χρόνια ( Nicéphore
            Niépce, 1826 ) τις σημαντικές στιγμές της ανθρωπότητας.
          </p>
          <p
            class="font-weight-light px-11 mb-11 text-center"
            style="max-width: 800px"
          >
            Ο νέος τρόπος επικοινωνίας όμως δεν μας εμπόδισε να γιορτάσουμε όλοι
            μαζί γιορτές, γενέθλια, Ανάσταση, Πάσχα και πολλές άλλες στιγμές
            γιατί…
          </p>
          <p
            class="font-weight-light px-11 mb-11 text-center"
            style="max-width: 800px"
          >
            …η Μετάπολις είμαστε εμείς
          </p>
          <p
            class="font-weight-light px-11 mb-11 text-center"
            style="max-width: 800px"
          >
            Κάθε κομμάτι που συνθέτει την πόλη, καθένας από εμάς που την
            κουβαλάμε μέσα μας, κάθε διαδρομή της που δημιουργούμε με τα βήματά
            μας, κάθε τι που ζούμε, που αγαπάμε, που μισούμε, που ονειρευόμαστε,
            κάθε δρόμος που χάνουμε και κάθε μονοπάτι που βρίσκουμε… εικόνες από
            την Μετάπολις και σκέψεις είναι εδώ…
          </p>
          <p
            class="font-weight-light px-11 mb-11 text-center"
            style="max-width: 800px"
          >
            …η Μετάπολις είμαστε εμείς
          </p>
        </div>
      </div>
    </v-sheet>
  </v-dialog>
</template>

<script>
export default {
  name: "Banner",
  props: {
    body: {
      type: String
    }
  },
  data() {
    return {
      dialog: true
    };
  }
};
</script>

<style scoped></style>
